import { Modal } from '@affine/component';
import { SelectPage } from '@affine/core/components/page-list/docs/select-page';
import type {
  DialogComponentProps,
  WORKSPACE_DIALOG_SCHEMA,
} from '@affine/core/modules/dialogs';
import { cssVar } from '@streamlain/theme';

export const DocSelectorDialog = ({
  close,
  init: selectedDocIds,
  singleSelect,
  onBeforeConfirm,
}: DialogComponentProps<WORKSPACE_DIALOG_SCHEMA['doc-selector']>) => {
  const confirm = (ids: string[]) => {
    if (onBeforeConfirm) {
      onBeforeConfirm(ids, () => close(ids));
      return;
    }
    close(ids);
  };

  return (
    <Modal
      open
      onOpenChange={() => close()}
      withoutCloseButton
      width="calc(100% - 32px)"
      height="80%"
      contentOptions={{
        style: {
          padding: 0,
          maxWidth: 976,
          background: cssVar('backgroundPrimaryColor'),
        },
      }}
    >
      <SelectPage
        init={singleSelect ? selectedDocIds.slice(0, 1) : selectedDocIds}
        singleSelect={singleSelect}
        onCancel={() => close()}
        onConfirm={confirm}
      />
    </Modal>
  );
};
